module.exports = __webpack_public_path__ + "static/img/service_introduce_5120_zh_h5.9a4c83e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5120_zh_h5.png
// module id = vmpn
// module chunks = 34